import { useState } from "react";

import Button from "components/Button";
import HollowButton from "components/HollowButton";

import { ICouncilGuest, ISaveCouncilGuestRequest } from "dto/Council/ICouncil";

import styles from "./styles.module.scss";

interface Props {
  /** null → nowy gość; obiekt → edycja. */
  guest: ICouncilGuest | null;
  loading?: boolean;
  onClose: () => void;
  onApply: (request: ISaveCouncilGuestRequest) => void;
}

// Gość sesji — odwzorowanie NewGuestModal z Magistratu (imię, nazwisko, funkcja,
// płeć sterująca formą gramatyczną w wydrukach).

const GuestModal = ({ guest, loading = false, onClose, onApply }: Props) => {
  const [firstName, setFirstName] = useState(guest?.FirstName ?? "");
  const [lastName, setLastName] = useState(guest?.LastName ?? "");
  const [role, setRole] = useState(guest?.Role ?? "");
  const [male, setMale] = useState(guest?.Male ?? true);

  // Magistrat wymaga obu pól — lista i wydruki pokazują „{Nazwisko} {Imię}".
  const canApply = !!firstName.trim() && !!lastName.trim();

  const submit = () => {
    if (!canApply) return;

    onApply({
      Id: guest?.Id ?? null,
      FirstName: firstName.trim() || null,
      LastName: lastName.trim() || null,
      Role: role.trim() || null,
      Male: male,
    });
  };

  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <div className={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div className={styles.modalTitle}>{guest ? "Edytuj gościa" : "Nowy gość"}</div>

        <div className={styles.modalBody}>
          <div className={styles.fieldRow}>
            <div className={styles.field}>
              <label className={styles.fieldLabel}>Imię</label>
              <input
                className={styles.textInput}
                value={firstName}
                autoFocus
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>

            <div className={styles.field}>
              <label className={styles.fieldLabel}>Nazwisko</label>
              <input
                className={styles.textInput}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.field}>
            <label className={styles.fieldLabel}>Funkcja</label>
            <input
              className={styles.textInput}
              value={role}
              onChange={(e) => setRole(e.target.value)}
              placeholder="np. Skarbnik, Sołtys"
            />
          </div>

          <div className={styles.radioRow}>
            <label className={styles.radioOption}>
              <input type="radio" checked={male} onChange={() => setMale(true)} />
              Mężczyzna
            </label>
            <label className={styles.radioOption}>
              <input type="radio" checked={!male} onChange={() => setMale(false)} />
              Kobieta
            </label>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <HollowButton text="Anuluj" onClick={onClose} />
          <Button
            text={guest ? "Zapisz" : "Dodaj"}
            loading={loading}
            disabled={!canApply}
            onClick={submit}
          />
        </div>
      </div>
    </div>
  );
};

export default GuestModal;
